module.exports = __webpack_public_path__ + "img/syndesia-logo.e3815eb4.svg";